import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
//import {GetDetalleOficio, GetGiro, PutOficios,GetPGIR,POSTPGIR,UPDPersona,GetMunicipios,GetCategorias,GetSubCategorias,GetColonias,GetAreas,ActAtencionReporte,GetUsuariosID,PostFileTarjeta, RegPersona, RegUsuario, PostFileImagen} from '../../services/SecurityService'
import {Modal,Button,Col,Row,Container} from 'react-bootstrap'
import PropTypes from 'prop-types';

import { DropdownList } from 'react-widgets';


import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Stepper from "awesome-react-stepper";

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {withStyles,styled } from '@material-ui/core/styles';
import { Document, Page, Text, View, StyleSheet , PDFViewer, PDFDownloadLink,Image, Font} from "@react-pdf/renderer";

import ttwb from './TitilliumWeb-Black.ttf'
import ttwbb from './TitilliumWeb-Bold.ttf'
import ttwbr from './TitilliumWeb-Regular.ttf'
 import styles2 from './DatosPersona.css'
import Calendar from 'react-calendar';
import { CorreoCartillas, GetCitasDisponibles, POSTCC, POSTPreregistro } from '../../services/SecurityService';
import 'react-calendar/dist/Calendar.css';

Font.register({ family: 'TitilliumWeb-Black', src:ttwb });
Font.register({ family: 'TitilliumWeb-Bold', src:ttwbb });
Font.register({ family: 'TitilliumWeb-Regular', src:ttwbr });

 class DatosPersona extends Component {
  
  constructor(props) {
    
    super(props);
    


    this.togglePassword=this.togglePassword.bind(this);

  

this.onChangeFechaRegistro = this.onChangeFechaRegistro.bind(this);
this.onChangeCURP = this.onChangeCURP.bind(this);
this.onChangeNombre = this.onChangeNombre.bind(this);
this.onChangeApellidoPaterno = this.onChangeApellidoPaterno.bind(this);
this.onChangeApellidoMaterno = this.onChangeApellidoMaterno.bind(this);
this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
this.onChangeOcupacion = this.onChangeOcupacion.bind(this);
this.onChangeLeer = this.onChangeLeer.bind(this);
this.onChangeDomicilio = this.onChangeDomicilio.bind(this);
this.onChangeCorreo = this.onChangeCorreo.bind(this);
this.onChangeTelefono = this.onChangeTelefono.bind(this);
this.onChangeFechaNacimiento = this.onChangeFechaNacimiento.bind(this);
this.onChangeLugarNacimiento = this.onChangeLugarNacimiento.bind(this);



this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);


        this.handleShow2 = this.handleShow2.bind(this);
        this.handleClose2 = this.handleClose2.bind(this);

    this.state = {
    
      FechaRegistro: '',
      passwordType:'password',
      
      show: false,
      show2:false,
     
      CURP: '',
      Nombre:'',
      ApellidoPaterno:'',
      ApellidoMaterno:'',
      EstadoCivil:'',
      Ocupacion: '',
      Leer: '',
      Domicilio:'',
      Correo:'',
      Telefono:'',
      FechaNacimiento : "",
      LugarNacimiento : "",

      hora_cita:'',
      aaa:new Date()
      
     
 
   
  }

 

}
  handleClose() {
    this.setState({ show: false });
  }
  
  handleShow() {
    this.setState({ show: true });
  }


  handleClose2() {
    this.setState({ show2: false });
  }
  
  handleShow2() {
    this.setState({ show2: true });
  }

  togglePassword =()=>{
    if(this.state.passwordType==="password")
    {
     this.setState({passwordType:"text"})
     return;
    }
    this.setState({passwordType:"password"})
  }
  
  
  
  componentDidMount(){
    console.log("idoficio");
    console.log(this.props.id_oficio)

    console.log("PROPS DATOSasd--->");
    console.log(this.props);
  
    let fecha = new Date();
    let aActual = fecha.getFullYear();
    let hoy = fecha.getDate();
    if(hoy<10){
      hoy='0'+hoy;
    }
let mesActual = fecha.getMonth() + 1; 
if(mesActual<10){
  mesActual='0'+mesActual;
}
let aa=aActual+'-'+mesActual+'-'+hoy;
    GetCitasDisponibles({fecha:aa}).then(response => {
      console.log(response)

      if(response!="No existen clientes en la BBDD."){
        this.setState({citas_disponibles:response.map(d=>d.fecha_hora),hora_cita:response[0].fecha_hora})
      }else{
  this.setState({citas_disponibles:[],hora_cita:''})

}

 
  }).catch(err => console.log(err));  

  const fechaActual = new Date();

// Sumar 14 días a la fecha actual
const fechaSumada = new Date(fechaActual);
fechaSumada.setDate(fechaSumada.getDate() + 14);

this.setState({aaa:fechaSumada})


}





onChangeFechaRegistro(e) {
  this.setState({
  NoFolio: e.target.value
  });
  }

  
       


                                                          onChangeCURP(e) {
                                                            const inputValue = e.target.value;
                                                            const maxLength = 18;
                                                            const trimmedValue = inputValue.slice(0, maxLength); // Recorta el valor a 18 caracteres como máximo
                                                            this.setState({ CCurp: trimmedValue });
                                                            this.setState({
                                                            CURP: trimmedValue.toUpperCase()
                                                            }) 
                                                            }onChangeNombre(e) {
                                                              this.setState({
                                                              Nombre: e.target.value.toUpperCase()
                                                              }) 
                                                              }onChangeApellidoPaterno(e) {
                                                                this.setState({
                                                                ApellidoPaterno: e.target.value.toUpperCase()
                                                                }) 
                                                                }onChangeApellidoMaterno(e) {
                                                                  this.setState({
                                                                  ApellidoMaterno: e.target.value.toUpperCase()
                                                                  }) 
                                                                  }onChangeEstadoCivil(e) {
                                                                    this.setState({
                                                                    EstadoCivil: e.target.value
                                                                    }) 
                                                                    }onChangeOcupacion(e) {
                                                                      this.setState({
                                                                      Ocupacion: e.target.value
                                                                      }) 
                                                                      }onChangeLeer(e) {
                                                                        this.setState({
                                                                        Leer: e.target.value
                                                                        }) 
                                                                        }
                                                                        onChangeDomicilio(e) {
                                                                          this.setState({
                                                                          Domicilio: e.target.value.toUpperCase()
                                                                          }) 
                                                                          }
                                                                          onChangeCorreo(e) {
                                                                            this.setState({
                                                                            Correo: e.target.value
                                                                            }) 
                                                                            }
                                                                            onChangeTelefono(e) {
                                                                              this.setState({
                                                                              Telefono: e.target.value
                                                                              }) 
                                                                              }

                                                                              onChangeFechaNacimiento(e) {
                                                                                this.setState({
                                                                                FechaNacimiento: e.target.value
                                                                                }) 
                                                                                }

                                                                                onChangeLugarNacimiento(e) {
                                                                                  this.setState({
                                                                                  LugarNacimiento: e.target.value.toUpperCase()
                                                                                  }) 
                                                                                  }



            pdf(obj){

              console.log("aqui esta imp");
              console.log(obj);
            
              var hoy = new Date();         
            
            let firmas=obj;
            
            
              return  (
                <Document >
           
            
              </Document>
            
            
            
            );
            
            
              }

              pdf2(obj){

                console.log("aqui esta imp");
                console.log(obj);
              
                var hoy = new Date();         
              
              let firmas=obj;
              
              
                return  (
                  <Document >
               
               
                </Document>
              
              
              
              );
              
              
                }

  onSubmit(e) {
  e.preventDefault();


  }




onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
};




  render() {
    let { value3,Giro} = this.state;
    const { classes} = this.props;

    let bloqueado;

    if(this.props.userLG!=453){
      bloqueado = 'readOnly';
    }
    let { vcategorias, Categorias, SubCategorias,Areas,vareas,filtroSub,vsubcategorias, Colonias,vcolonias,Municipios,vmunicio,Emisor, Persona} = this.state;
    
    
let botons;
let msj;


let foraneo;
let mf;
if(this.state.vmunicio!=undefined){
  console.log("vmunicipio");
  console.log(this.state.vmunicio)
  mf=this.state.vmunicio.nombre;

}
    if(mf=="Foraneo"){
      foraneo= [<label>Ingrese Municipio/Estado </label>,<input 
      type="text" 
      required
      className="form-control" 
      value={this.state.foraneo}
      onChange={this.onChangeForaneo}
     
      />]
    }


    let subcategoria;
    let cc;

    if(this.state.vcategorias!=undefined){
      console.log("categoria");
      console.log(this.state.vcategorias)
      cc=this.state.vcategorias;
    
    }

    if(cc==2 || cc==5 || cc==11 ){
      subcategoria= <Grid item xs={6}>
      <label>SubCategoria: </label>
     <DropdownList 
     required
     filter
             data={SubCategorias}
             value={vsubcategorias}
             allowCreate="onFilter"
             
             style={{  width: '100%' }}
             onChange={descripcion => this.onChangeSubCategorias(descripcion)}
             textField="subcategoria"
             placeholder="SubCategoria..."
           />                 
     </Grid>
    }

  

  const deshabilitarDiasNoHabiles = ({ date }) => {
    // Obtener el día de la semana (0 para domingo, 1 para lunes, etc.)
    const diaSemana = date.getDay();
    // Devolver verdadero para deshabilitar si es sábado (6) o domingo (0)
    return diaSemana === 0 || diaSemana === 6;
  };

    return (


      
        <div style={{ }}>


<br/>


<Stepper
style={{marginTop:'10px'}}
strokeColor="#17253975"
barWidth='20'
btnPos='center'
allowClickControl="false"
  fillStroke="#88213a"
  activeColor="#88213a"
  activeProgressBorder="2px solid #88213a"
  submitBtn={<button style={{backgroundColor:'#88213a',color:'#FFFFFF',borderRadius:'40px',border: 'none',margin:'1.4em',padding:'0.7em 1.6em',outline:'none',boxShadow:'none'}}>Generar cita</button>}
  continueBtn={<button style={{backgroundColor:'#88213a',color:'#FFFFFF',borderRadius:'40px',border: 'none',margin:'1.4em',padding:'0.7em 1.6em',outline:'none',boxShadow:'none'}}>Continuar</button>}
  backBtn={<button style={{backgroundColor:'#d68095',color:'#FFFFFF',borderRadius:'40px',border: 'none',margin:'1.4em',padding:'0.7em 1.6em',outline:'none',boxShadow:'none'}}>Atras</button>}
  onSubmit={
    (step) => {

      if(this.state.hora_cita==''){
        alert('Debe seleccionar una hora de la cita!');
        
      }

      else if(this.state.ApellidoPaterno=='' || 
              this.state.ApellidoMaterno=='' ||
              this.state.nombre=='' ||
              this.state.fecha_nac=='' ||
              this.state.lugar_nac=='' ||
              this.state.estado_civil=='' ||
              this.state.ocupacion=='' ||
              this.state.leer_escribir=='' ||
              this.state.CURP=='' ||
              this.state.domicilio=='' ||
              this.state.correo=='' ||
              this.state.telefono) {
        alert('Registre todos los campos');
        }
      else{
      const obj = {
     
     
        ap_paterno: this.state.ApellidoPaterno,
        ap_materno: this.state.ApellidoMaterno,
        nombre: this.state.Nombre,
        hora_cita:this.state.hora_cita,
        fecha_nac: this.state.FechaNacimiento,
        lugar_nac: this.state.LugarNacimiento,
       // nombre_padre: this.state.CNombrePadre,
       // nombre_madre: this.state.CNombreMadre,
       // tutor: this.state.CTutor,
        estado_civil: this.state.EstadoCivil,
        ocupacion: this.state.Ocupacion,
        leer_escribir: this.state.Leer,
        CURP: this.state.CURP,
      //  nivel_estudios: this.state.CNivelEstudios,
      //  grado: this.state.CGradoMaximo,
        domicilio: this.state.Domicilio,
        correo: this.state.Correo,
        telefono: this.state.Telefono,
        
       
        //Derecha v Locales, izquierda Base de datos
  
      };
      console.log("cita obj");
      console.log(obj);
  
      POSTPreregistro(obj).then(response => {
       
        console.log("Aqui ese supone q se registro")
        console.log(response);
       // window.location.reload();
       if(response!="error en el servidor."){

        let oob={

          fecha_cita:this.state.hora_cita,
          correo: this.state.Correo,
          telefono: this.state.Telefono,
          id_preregistro:response
        }
        console.log("cita oob");
        console.log(oob);
        let objcorreo={
          fecha:this.state.hora_cita,
          correo: this.state.Correo,
          nombre: this.state.Nombre+" "+this.state.ApellidoPaterno+" "+this.state.ApellidoMaterno,
          curp: this.state.CURP,
        }
                  CorreoCartillas(objcorreo).then(response => {
        
                    //console.log("Registrarr USUSER<<><")
                    console.log(response);
                  
                  
                    if(response=='Correo enviado correctamente.'){
                     
                    }
                    
                  }).catch(err => console.log(err));
        
        POSTCC(oob).then(response => {
       
          console.log("Aqui ese supone q se registro")
          console.log(response);
         // window.location.reload();
         if(response!="error en el servidor."){

          alert(`Gracias por agendar una cita, te mandamos un correo electrónico de confirmación`)
          window.location.reload();
        
        }
        }).catch(err => console.log(err)); 
        //window.location.reload();
      
      }
      }).catch(err => console.log(err)); 
      
    }
    
    }
  }
>
  
  <div style={{margin:'1.4em',borderRadius:'12px',padding:'1.4em'}}>
  
  <form onSubmit={this.onSubmit}>
            <div className="form-group">
            <div class="container col-xxl-12 px-15 ">
    <div class="row flex-lg-row-reverse align-items-center g-5 ">
      <div class="col-10 col-sm-8 col-lg-6">
      <img src={require('./perfil.png')} style={{width:'90%'}} class="d-block mx-lg-auto img-fluid" alt="1" />
      </div>
      <div class="col-lg-6">
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
      <span style={{fontSize:'28px',backgroundColor:'#88213a'}} class="badge rounded-circle">1</span>
        </div>
        <h1 class="display-5 fw-bold  lh-1 mb-3" >Datos de nacimiento</h1>
     
        
      </div>
    </div>
  </div>

                <Grid container spacing={1} >
                <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>NOMBRE(S)</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.Nombre}
                      onChange={this.onChangeNombre}
                  
                     
                      />
                      </Grid>

                      <Grid style={{marginTop:'10px'}} item xs={6}>
                    <label style={{}}>APELLIDO PATERNO</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.ApellidoPaterno}
                      onChange={this.onChangeApellidoPaterno}
                  
                     
                      />
                      </Grid>

                      <Grid style={{marginTop:'10px'}} item xs={6}>
                    <label style={{}}>APELLIDO MATERNO</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.ApellidoMaterno}
                      onChange={this.onChangeApellidoMaterno}
                  
                     
                      />
                      </Grid>

                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>CURP</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.CURP}
                      onChange={this.onChangeCURP}
                  
                     
                      />
                      </Grid>
                      

                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>ESTADO CIVIL</label>
                   <br/>
                   <RadioGroup aria-label="emp_recolectora" name="emp_recolectora" value={this.state.EstadoCivil} onChange={this.onChangeEstadoCivil}>
                    <row>
          <FormControlLabel value="SOLTERO" control={<Radio />} label="Soltero" />
          <FormControlLabel value="CASADO" control={<Radio />} label="Casado" />
          </row>
      
        </RadioGroup>
                      </Grid>

                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>OCUPACIÓN</label>
                    <RadioGroup aria-label="emp_recolectora" name="emp_recolectora" value={this.state.Ocupacion} onChange={this.onChangeOcupacion}>
                    <row>
          <FormControlLabel value="ESTUDIANTE" control={<Radio />} label="Estudiante" />
          <FormControlLabel value="EMPLEADO" control={<Radio />} label="Empleado" />
          </row>
      
        </RadioGroup>
                      </Grid>

                    

                      

                
                 </Grid>
                
                    

                </div>
              





                <>
            
      
                <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show} onHide={this.handleClose} >
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
              {/*    <PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie"+this.props.obj.id+".pdf"}>
    this.pdf(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>

              <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show2} onHide={this.handleClose2}>
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
  {/*<PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie2"+this.props.obj.id+".pdf"}>
    this.pdf2(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>
              
     

            
            </>
            
                <div className="form-group">
                  { <input  ref="inputR"
                  disabled={this.state.botondisabled}
                    style={{color:'#4885ed',borderColor:'#4885ed',display:'none'}} variant="outlined" type="submit" value="ACTUALIZAR"  className="btn btn-outline"/>  }
                   
    
              
              
                </div>
                

            </form>
  </div>
  <div style={{margin:'1.4em',borderRadius:'12px',padding:'1.4em'}}>
  <br/>
  <form onSubmit={this.onSubmit}>
            <div className="form-group">
              
            <div class="container col-xxl-12 px-15 ">
    <div class="row flex-lg-row-reverse align-items-center g-5 ">
      <div class="col-10 col-sm-8 col-lg-6">
      <img src={require('./datos.png')} style={{width:'90%'}} class="d-block mx-lg-auto img-fluid" alt="2"  />
      </div>
      <div class="col-lg-6">
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
      <span style={{fontSize:'28px',backgroundColor:'#88213a'}} class="badge rounded-circle">2</span>
        </div>
        <h1 class="display-5 fw-bold  lh-1 mb-3">Datos personales</h1>
        
      </div>
    </div>
  </div>
                <br></br>
                <Grid container spacing={1} >
                <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>¿Sabe leer y escribir?</label>
                    <RadioGroup aria-label="emp_recolectora" name="emp_recolectora" value={this.state.Leer} onChange={this.onChangeLeer}>
                    <row>
          <FormControlLabel value="SI" control={<Radio />} label="Si" />
          <FormControlLabel value="NO" control={<Radio />} label="No" />
          </row>
      
        </RadioGroup>
                      </Grid>
                      <p></p>
                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>Domicilio</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.Domicilio}
                      onChange={this.onChangeDomicilio}
                  
                     
                      />
                      </Grid>
                      <br/>
                      <Grid style={{marginTop:'10px'}} item xs={6}>
                    <label style={{}}>Correo electrónico</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.Correo}
                      onChange={this.onChangeCorreo}
                  
                     
                      />
                      </Grid>
                      
                      <Grid style={{marginTop:'10px'}} item xs={6}>
                    <label style={{}}>Número de teléfono</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.Telefono}
                      onChange={this.onChangeTelefono}
                  
                     
                      />
                      </Grid>
                      <br/>

                      <br/>
                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>Fecha de nacimiento</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="date" 
                      required
                      className="form-control" 
                      value={this.state.FechaNacimiento}
                      onChange={this.onChangeFechaNacimiento}
                      max={`${new Date().getFullYear()}-12-31`}
                     
                      />
                      </Grid>
                      <br/>
                      <Grid style={{marginTop:'10px'}} item xs={12}>
                    <label style={{}}>Lugar de nacimiento</label>
                    <input style={{borderColor:'#e9ecef',borderWidth:1.5}}
                      type="text" 
                      required
                      className="form-control" 
                      value={this.state.LugarNacimiento}
                      onChange={this.onChangeLugarNacimiento}
                  
                     
                      />
                      </Grid>
                      <br/>
                    

                      

                
                 </Grid>
                
                    

                </div>
              





                <>
            
      
                <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show} onHide={this.handleClose} >
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
              {/*    <PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie"+this.props.obj.id+".pdf"}>
    this.pdf(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>

              <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show2} onHide={this.handleClose2}>
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
  {/*<PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie2"+this.props.obj.id+".pdf"}>
    this.pdf2(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>
              
     

            
            </>
            
                <div className="form-group">
                  { <input  ref="inputR"
                  disabled={this.state.botondisabled}
                    style={{color:'#4885ed',borderColor:'#4885ed',display:'none'}} variant="outlined" type="submit" value="ACTUALIZAR"  className="btn btn-outline"/>  }
                   
    
              
              
                </div>
                

            </form>
  </div>
  
  <div style={{margin:'1.4em',borderRadius:'12px',padding:'1.4em'}}>
  <div class="container col-xxl-12 px-15 ">
    <div class="row flex-lg-row-reverse align-items-center g-5 ">
      <div class="col-10 col-sm-8 col-lg-6">
      <img src={require('./agenda.png')} style={{width:'100%'}} class="d-block mx-lg-auto img-fluid" alt="3"  />
      </div>
      <div class="col-lg-6">
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
      <span style={{fontSize:'28px',backgroundColor:'#88213a'}} class="badge rounded-circle">3</span>
        </div>
        <h1 class="display-5 fw-bold  lh-1 mb-3">Agenda tu cita</h1>
        
      </div>
    </div>
  </div>
  <form onSubmit={this.onSubmit}>
            <div className="form-group">
                  <div style={{borderWidth:"1px",borderColor:"#e9ecef",borderRadius:'40px',borderStyle:"solid"}}>
                  <br/>
                  <br/>
                  <Grid container spacing={1} >
                    
                  <Grid style={{}} item xs={1}>
</Grid>
                  <Grid style={{marginTop:'10px'}} item xs={12} md={5}>
                  
      <Calendar 
      minDetail='month'
      minDate={new Date()}
      maxDate={this.state.aaa}
      tileDisabled={deshabilitarDiasNoHabiles}
      style={{borderRadius:"20px",padding:'0.7em 1.6em',marginTop:"5px",borderColor:"red"}} onChange={(e)=>{

        this.setState({fecha_cita:e,hora_cita:''})



        let fecha = new Date(e);
        let aActual = fecha.getFullYear();
        let hoy = fecha.getDate();
        if(hoy<10){
          hoy='0'+hoy;
        }
    let mesActual = fecha.getMonth() + 1; 
    if(mesActual<10){
      mesActual='0'+mesActual;
    }
    let aa=aActual+'-'+mesActual+'-'+hoy;
        GetCitasDisponibles({fecha:aa}).then(response => {
          console.log(response)
    
          if(response!="No existen clientes en la BBDD."){
            this.setState({citas_disponibles:response.map(d=>d.fecha_hora),hora_cita:response[0].fecha_hora})
          }else{
        this.setState({citas_disponibles:[],hora_cita:''})

      }
    
     
      }).catch(err =>   this.setState({citas_disponibles:[]}));  

      }} value={this.state.fecha_cita} />



      
      </Grid>

      <Grid style={{marginTop:'10px'}} item xs={12} md={5}>
     {this.state.citas_disponibles=='' ? 'No hay citas disponibles' : <DropdownList style={{backgroundColor:"#e9ecef",borderRadius:"20px",color:"#000000"}}
      value={this.state.hora_cita}
      onChange={(nextValue) => this.setState({hora_cita:nextValue})}
      data={this.state.citas_disponibles}
    />    }  
    </Grid>

    <Grid style={{}} item xs={1}>
</Grid>
    </Grid>
    <br/>
    <br/>
    
    

    <br/>
    

    </div>


   

                
                <Grid container spacing={1} >
                
                   

                      

                
                 </Grid>
                 <Grid container spacing={1} >
                 
                

                      


                   
                     
                       

<Grid container spacing={1} >

  
                    


                      


                                            </Grid>  

                    </Grid>
                    

                </div>
              





                <>
            
      
                <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show} onHide={this.handleClose} >
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
              {/*    <PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie"+this.props.obj.id+".pdf"}>
    this.pdf(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>

              <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
               style={{marginTop:40}}
              show={this.state.show2} onHide={this.handleClose2}>
                <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
  {/*<PDFViewer width={'100%'} height={600} fileName={"tarjeta_sonrie2"+this.props.obj.id+".pdf"}>
    this.pdf2(this.props.obj)
    </PDFViewer>
*/}
                </Modal.Body>
                
              </Modal>
              
     

            
            </>
            
                <div className="form-group">
                  { <input  ref="inputR"
                  disabled={this.state.botondisabled}
                    style={{color:'#4885ed',borderColor:'#4885ed',display:'none'}} variant="outlined" type="submit" value="ACTUALIZAR"  className="btn btn-outline"/>  }
                   
    
              
              
                </div>
                

            </form>
  </div>
</Stepper>

            
            
        </div>
    )
  }
}


const styles = {
  card: {
    maxWidth: 500,
    borderRadius:15,
  },
  media: {
    objectFit: 'cover',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  searchBar: {
    color: 'white',
    marginLeft: 6
  },
  list:{
  borderColor:'#A11B39',
  borderWidth:2
  }
};

DatosPersona.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
};

export default withStyles(styles)(DatosPersona);